module.exports = __webpack_public_path__ + "static/media/google-event.6159e423.jpg";